import { render, staticRenderFns } from "./SaleAIModelSection.vue?vue&type=template&id=b31ece3e"
import script from "./SaleAIModelSection.vue?vue&type=script&lang=js"
export * from "./SaleAIModelSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports